<template>
  <div class="background">
    <Header />
    <slot /> <!-- This is where the content of `ahli.vue` will be injected -->
  </div>
</template>


<style scoped>
.background {
  display: flex;
  box-sizing: border-box;
  flex-direction: column;
  align-items: center;
  background-attachment: fixed;
  background-image: url("@/assets/jkt/oscBackground.png");
  background-position: center;
  background-size: cover;
  color: white;
  min-block-size: 100vh;
}

header {
  padding: 10px;
  inline-size: 100%;
}

.top-bar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-block: 10px;
  padding-inline: 20px;
}

.logo {
  block-size: 45px;
}

.nav-links {
  display: flex;
  gap: 20px;
  text-decoration: underline;
}

.nav-links a {
  color: white;
  font-size: 1rem;
  text-decoration: none;
}

.nav-links a:hover {
  text-decoration: underline;
}

@media (max-width: 768px) {
  .top-bar {
    padding-inline: 15px;
  }

  .logo {
    block-size: 35px;
    inline-size: auto;
  }

  .nav-links {
    font-size: 0.9rem;
    gap: 15px;
  }
}

/* Small screen adjustments (480px and below) */
@media (max-width: 480px) {
  .top-bar {
    flex-direction: column;
    align-items: center;
    padding-inline: 10px;
    text-align: center;
  }

  .logo {
    block-size: 30px;
    margin-bottom: 10px;
  }

  .nav-links {
    display: none; /* Hide the navigation links on small screens to save space */
  }
}
</style>
